import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_serial_numbers_by_materialIdsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialIds?: number[], vendorLotCode?: string, serialNumberCode?: string }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LicensePlate?: { Id?: number, LookupCode?: string, ShippingContainerId?: number, WarehouseId?: number, Location?: { Id?: number, Name?: string }, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } } }[] }> 
  {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serial_numbers_by_materialIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialIds?: number[], vendorLotCode?: string, serialNumberCode?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LicensePlate?: { Id?: number, LookupCode?: string, ShippingContainerId?: number, WarehouseId?: number, Location?: { Id?: number, Name?: string }, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serial_numbers_by_materialIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialIds?: number[], vendorLotCode?: string, serialNumberCode?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LicensePlate?: { Id?: number, LookupCode?: string, ShippingContainerId?: number, WarehouseId?: number, Location?: { Id?: number, Name?: string }, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serial_numbers_by_materialIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
